import { useState, useEffect } from 'react';
import { getWorkers, getWorkersEarnings, verifyKyc, verifyBank, removeWorker } from '../services/api';
import api from '../services/api';
import axios from 'axios';

const BASE = 'http://localhost:8000/api/v1';
const token = () => localStorage.getItem('admin_token');

const skills = ['AC', 'Plumbing', 'Electrical', 'Cleaning', 'Carpentry', 'Painting', 'Pest Control', 'Beauty'];

export default function Workers() {
  const [workers, setWorkers] = useState([]);
  const [earnings, setEarnings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [view, setView] = useState('workers'); // 'workers' or 'earnings'
  const [showForm, setShowForm] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', phone: '', password: 'worker123', skill_category: 'AC', experience_years: 1 });

  useEffect(() => { loadWorkers(); }, []);

  const loadWorkers = async () => {
    setLoading(true);
    try {
      const [w, e] = await Promise.all([getWorkers(), getWorkersEarnings()]);
      setWorkers(w);
      setEarnings(e);
    } catch (e) {}
    setLoading(false);
  };

  const handleVerify = async (id) => {
    if (!window.confirm('Approve KYC for this worker?')) return;
    try { await verifyKyc(id); loadWorkers(); } catch (e) { alert('Failed'); }
  };

  const handleVerifyBank = async (id) => {
    if (!window.confirm('Verify bank details for this worker?')) return;
    try { await verifyBank(id); loadWorkers(); } catch (e) { alert(e.response?.data?.detail || 'Failed'); }
  };

  const handleReject = async (id) => {
    const reason = prompt('Rejection reason:', 'Document unclear or invalid. Please re-upload a clear photo.');
    if (!reason) return;
    try {
      await axios.put(`${BASE}/admin/workers/${id}/reject-kyc`, { reason }, {
        headers: { Authorization: `Bearer ${token()}`, 'Content-Type': 'application/json' }
      });
      loadWorkers();
    } catch (e) { alert(e.response?.data?.detail || 'Failed to reject'); }
  };

  const handleAddWorker = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      // Step 1: Register user
      const regRes = await axios.post(`${BASE}/auth/register`, {
        name: form.name, email: form.email, phone: form.phone,
        password: form.password, role: 'worker'
      }, { headers: { Authorization: `Bearer ${token()}` } });

      if (!regRes.data.id) { alert(regRes.data.detail || 'Registration failed'); setSaving(false); return; }

      // Step 2: Login as new worker to get token
      const loginForm = new URLSearchParams();
      loginForm.append('username', form.email);
      loginForm.append('password', form.password);
      const loginRes = await axios.post(`${BASE}/auth/login`, loginForm);
      const workerToken = loginRes.data.access_token;

      // Step 3: Onboard worker
      await axios.post(`${BASE}/workers/onboard`, {
        skill_category: form.skill_category,
        experience_years: parseInt(form.experience_years)
      }, { headers: { Authorization: `Bearer ${workerToken}` } });

      // Step 4: Worker needs to upload KYC document from their app
      // KYC will be verified manually after document review

      alert(`✅ Worker created!\nEmail: ${form.email}\nPassword: ${form.password}`);
      setShowForm(false);
      setForm({ name: '', email: '', phone: '', password: 'worker123', skill_category: 'AC', experience_years: 1 });
      loadWorkers();
    } catch (e) {
      alert(e.response?.data?.detail || 'Failed to create worker');
    }
    setSaving(false);
  };

  const handleRemove = async (id) => {
    if (!window.confirm('Remove this worker? Their active bookings will be unassigned and their account deactivated.')) return;
    try { await removeWorker(id); loadWorkers(); }
    catch (e) { alert(e.response?.data?.detail || 'Failed to remove worker'); }
  };

  const handlePayWorker = async (workerId, name, amount) => {
    if (!window.confirm(`Mark ₹${amount.toFixed(2)} as paid to ${name}? Make sure you have transferred the amount to their bank account.`)) return;
    try {
      const res = await api.put(`/admin/workers/${workerId}/pay`, { amount });
      alert(`✅ ${res.data.message}\nRemaining pending: ₹${res.data.pending}`);
      loadWorkers();
    } catch (e) { alert(e.response?.data?.detail || 'Failed'); }
  };
  const filtered = workers.filter(w => {
    if (!search.trim()) return true;
    const q = search.toLowerCase();
    return String(w.id).includes(q) ||
           w.skill_category.toLowerCase().includes(q) ||
           (w.user?.name || '').toLowerCase().includes(q) ||
           (w.user?.phone || '').includes(q) ||
           (w.user?.email || '').toLowerCase().includes(q);
  });

  return (
    <div>
      <div className="page-header">
        <h1>Workers Management</h1>
        <p>Manage all registered workers and KYC verification</p>
      </div>

      {showForm && (
        <div className="card">
          <div className="card-header">
            <h2>➕ Add New Worker</h2>
            <button className="btn btn-danger btn-sm" onClick={() => setShowForm(false)}>✕ Close</button>
          </div>
          <form onSubmit={handleAddWorker}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
              <div className="form-group">
                <label>Full Name</label>
                <input value={form.name} onChange={e => setForm({...form, name: e.target.value})} required placeholder="Enter full name" />
              </div>
              <div className="form-group">
                <label>Email</label>
                <input type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} required placeholder="worker@example.com" />
              </div>
              <div className="form-group">
                <label>Phone</label>
                <input value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} required placeholder="10 digit phone number" />
              </div>
              <div className="form-group">
                <label>Password</label>
                <input value={form.password} onChange={e => setForm({...form, password: e.target.value})} required />
              </div>
              <div className="form-group">
                <label>Skill Category</label>
                <select value={form.skill_category} onChange={e => setForm({...form, skill_category: e.target.value})}>
                  {skills.map(s => <option key={s} value={s}>{s}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label>Experience (Years)</label>
                <input type="number" value={form.experience_years} onChange={e => setForm({...form, experience_years: e.target.value})} min="0" max="50" />
              </div>
            </div>
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? 'Creating Worker...' : '✅ Create Worker'}
            </button>
          </form>
        </div>
      )}

      <div className="card">
        <div className="card-header">
          <h2>🔧 All Workers ({filtered.length})</h2>
          <div style={{ display: 'flex', gap: 8 }}>
            <input
              placeholder="🔍 Search by ID, name, skill, phone..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              style={{ padding: '6px 12px', border: '1px solid #ddd', borderRadius: 8, fontSize: 13 }}
            />
            <button className="btn btn-primary btn-sm" onClick={() => setShowForm(!showForm)}>➕ Add Worker</button>
            <button className={`btn btn-sm ${view === 'earnings' ? 'btn-success' : 'btn-secondary'}`}
              onClick={() => setView(view === 'earnings' ? 'workers' : 'earnings')}>
              {view === 'earnings' ? '👥 Workers View' : '💰 Earnings View'}
            </button>
            <button className="refresh-btn" onClick={loadWorkers}>🔄 Refresh</button>
          </div>
        </div>
        {loading ? <div className="loading">Loading workers...</div> : view === 'earnings' ? (
          /* ── Earnings View ── */
          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Partner Name</th>
                  <th>Phone</th>
                  <th>Skill</th>
                  <th>Completed Jobs</th>
                  <th>This Week</th>
                  <th>This Month</th>
                  <th>Total Earnings</th>
                  <th>Paid</th>
                  <th>Pending</th>
                  <th>Pay</th>
                  <th>Bank / UPI</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {earnings
                  .filter(e => {
                    if (!search.trim()) return true;
                    const q = search.toLowerCase();
                    return String(e.id).includes(q) || e.name.toLowerCase().includes(q) || (e.phone || '').includes(q);
                  })
                  .map(e => (
                  <tr key={e.id}>
                    <td>#{e.id}</td>
                    <td><strong>{e.name}</strong><br/><span style={{fontSize:11,color:'#888'}}>{e.email}</span></td>
                    <td style={{color:'#1565c0',fontWeight:600}}>{e.phone}</td>
                    <td>{e.skill_category}</td>
                    <td><strong>{e.completed_jobs}</strong></td>
                    <td style={{color:'#16a34a',fontWeight:700}}>₹{e.weekly_earnings.toFixed(2)}</td>
                    <td style={{color:'#7c3aed',fontWeight:700}}>₹{e.monthly_earnings.toFixed(2)}</td>
                    <td style={{fontWeight:700,fontSize:15}}>₹{e.total_earnings.toFixed(2)}</td>
                    <td style={{color:'#16a34a',fontWeight:600}}>₹{(e.paid_amount || 0).toFixed(2)}</td>
                    <td style={{color: (e.pending_amount || 0) > 0 ? '#dc2626' : '#888', fontWeight:700}}>₹{(e.pending_amount || 0).toFixed(2)}</td>
                    <td>
                      {(e.pending_amount || 0) > 0 && (
                        <button className="btn btn-sm btn-success" onClick={() => handlePayWorker(e.id, e.name, e.pending_amount)}>
                          Pay ₹{(e.pending_amount || 0).toFixed(0)}
                        </button>
                      )}
                    </td>
                    <td style={{fontSize:12}}>
                      {e.bank_account ? (
                        <div>
                          <div>{e.bank_name} - {e.bank_account}</div>
                          <div>IFSC: {e.ifsc_code}</div>
                          {e.upi_id && <div><strong>UPI: {e.upi_id}</strong></div>}
                        </div>
                      ) : <span style={{color:'#aaa'}}>Not added</span>}
                    </td>
                    <td>
                      {e.bank_verified
                        ? <span className="badge badge-success">✅ Verified</span>
                        : <span className="badge badge-warning">⏳ Pending</span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {/* Summary */}
            <div style={{padding:'16px 20px',background:'#f8f9ff',borderTop:'1px solid #eee',display:'flex',gap:24,flexWrap:'wrap'}}>
              <div><span style={{color:'#888',fontSize:12}}>Total This Week:</span><br/><strong style={{color:'#16a34a',fontSize:18}}>₹{earnings.reduce((s,e)=>s+e.weekly_earnings,0).toFixed(2)}</strong></div>
              <div><span style={{color:'#888',fontSize:12}}>Total This Month:</span><br/><strong style={{color:'#7c3aed',fontSize:18}}>₹{earnings.reduce((s,e)=>s+e.monthly_earnings,0).toFixed(2)}</strong></div>
              <div><span style={{color:'#888',fontSize:12}}>Total All Time:</span><br/><strong style={{fontSize:18}}>₹{earnings.reduce((s,e)=>s+e.total_earnings,0).toFixed(2)}</strong></div>
              <div><span style={{color:'#16a34a',fontSize:12}}>Total Paid:</span><br/><strong style={{color:'#16a34a',fontSize:18}}>₹{earnings.reduce((s,e)=>s+(e.paid_amount||0),0).toFixed(2)}</strong></div>
              <div><span style={{color:'#dc2626',fontSize:12}}>Total Pending:</span><br/><strong style={{color:'#dc2626',fontSize:18}}>₹{earnings.reduce((s,e)=>s+(e.pending_amount||0),0).toFixed(2)}</strong></div>
              <div><span style={{color:'#888',fontSize:12}}>Total Completed Jobs:</span><br/><strong style={{fontSize:18}}>{earnings.reduce((s,e)=>s+e.completed_jobs,0)}</strong></div>
            </div>
          </div>
        ) : (
          /* ── Workers View ── */
          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name & Phone</th>
                  <th>Skill</th>
                  <th>Experience</th>
                  <th>Rating</th>
                  <th>Total Jobs</th>
                  <th>Total Earnings</th>
                  <th>Bank Details</th>
                  <th>Availability</th>
                  <th>KYC Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map(w => (
                  <tr key={w.id}>
                    <td>#{w.id}</td>
                    <td>
                      <div style={{ fontWeight: 600 }}>{w.user?.name || '—'}</div>
                      <div style={{ fontSize: 12, color: '#1565c0', fontWeight: 500 }}>📞 {w.user?.phone || '—'}</div>
                      <div style={{ fontSize: 12, color: '#555' }}>✉️ {w.user?.email || '—'}</div>
                    </td>
                    <td><strong>{w.skill_category}</strong></td>
                    <td>{w.experience_years} yrs</td>
                    <td>⭐ {Number(w.rating).toFixed(2)}</td>
                    <td>{w.total_jobs}</td>
                    <td>₹{Number(w.total_earnings || 0).toFixed(2)}</td>
                    <td>
                      {w.bank_account ? (
                        <div style={{ fontSize: 12 }}>
                          <div><strong>{w.bank_name || '—'}</strong></div>
                          <div>A/C: {w.bank_account}</div>
                          <div>IFSC: {w.ifsc_code || '—'}</div>
                          <div>Holder: {w.account_holder_name || '—'}</div>
                          {w.upi_id && <div>UPI: <strong>{w.upi_id}</strong></div>}
                          <div style={{ marginTop: 4 }}>
                            {w.bank_verified
                              ? <span className="badge badge-success" style={{ fontSize: 10 }}>✅ Verified</span>
                              : <>
                                  <span className="badge badge-warning" style={{ fontSize: 10 }}>⏳ Pending</span>
                                  <button className="btn btn-sm btn-success" style={{ marginLeft: 4, fontSize: 10, padding: '2px 6px' }}
                                    onClick={() => handleVerifyBank(w.id)}>Verify</button>
                                </>
                            }
                          </div>
                        </div>
                      ) : <span style={{ color: '#aaa', fontSize: 12 }}>Not added</span>}
                    </td>
                    <td>
                      {w.is_available
                        ? <span className="badge badge-success">Available</span>
                        : <span className="badge badge-grey">Busy</span>}
                    </td>
                    <td>
                      {w.kyc_verified
                        ? <span className="badge badge-success">✅ Verified</span>
                        : w.kyc_rejected
                          ? <span className="badge badge-danger">❌ Rejected</span>
                          : w.kyc_document_url
                            ? <span className="badge badge-warning">📄 Pending Review</span>
                            : <span className="badge badge-grey">⏳ Not Uploaded</span>}
                      {w.kyc_document_url && (
                        <div style={{ marginTop: 4 }}>
                          <a href={`${BASE.replace('/api/v1', '')}${w.kyc_document_url}`} target="_blank" rel="noreferrer"
                            style={{ fontSize: 11, color: '#1565c0', textDecoration: 'underline' }}>
                            📎 View {w.kyc_document_type === 'aadhaar' ? 'Aadhaar' : w.kyc_document_type === 'pan' ? 'PAN' : 'Document'}
                          </a>
                        </div>
                      )}
                    </td>
                    <td>
                      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                        {!w.kyc_verified && w.kyc_document_url && (
                          <button className="btn btn-sm btn-success" onClick={() => handleVerify(w.id)}>✅ Approve</button>
                        )}
                        {!w.kyc_verified && w.kyc_document_url && (
                          <button className="btn btn-sm btn-warning" onClick={() => handleReject(w.id)}>❌ Reject</button>
                        )}
                        {!w.kyc_verified && !w.kyc_document_url && (
                          <button className="btn btn-sm btn-success" onClick={() => handleVerify(w.id)}>✅ Verify Manually</button>
                        )}
                        <button className="btn btn-sm btn-danger" onClick={() => handleRemove(w.id)}>🗑️ Remove</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
